import { Requester } from './Requester';
import { SurveyStatus, ISurveyFull, ISurveyInvite } from '../types';

export interface IOrgOnboardingResponse {
    onboardingStatus: SurveyStatus;
    onboardingSurvey: ISurveyFull;
    onboardingInvites?: ISurveyInvite;
}

export const GetOrgOnboarding = async (orgId: string): Promise<IOrgOnboardingResponse | null> => {
    try {
        const response = await Requester<IOrgOnboardingResponse>({
            path: `organizations/${orgId}/onboarding`,
            method: 'GET'
        });

        return Object.hasOwn(response, 'onboardingStatus') ? (response as IOrgOnboardingResponse) : null;
    } catch (e) {
        console.error('Get org onboarding request failed');
        return Promise.reject(e);
    }
};
